import { render, staticRenderFns } from "./CreateOPCParam.vue?vue&type=template&id=b3001db8"
import script from "./CreateOPCParam.vue?vue&type=script&lang=js"
export * from "./CreateOPCParam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports